import { getGetStartedSettings, updateGetStartedSettings } from '../../../services/admin';
import { SavedSwitchSetting } from './SavedSwitchSetting';

const loadGetStartedEnabled = async (signal: AbortSignal) =>
  (await getGetStartedSettings(signal)).enabled;

const saveGetStartedEnabled = async (next: boolean, signal: AbortSignal) =>
  (await updateGetStartedSettings(next, signal)).enabled;

/**
 * The global switch for the Get Started checklist.
 *
 * Off means the onboarding endpoints answer 404 for everyone, which both clients already read as
 * "no checklist here" and hide every trace of it: the Players panel, the nav item and its dialog,
 * and the Settings card.
 */
export const GetStartedChecklistSetting = () => (
  <SavedSwitchSetting
    load={loadGetStartedEnabled}
    save={saveGetStartedEnabled}
    label="Show the Get Started checklist"
    description="When this is off, nobody sees Get Started on web or mobile."
    loadingText="Loading the Get Started setting..."
    loadErrorText="Could not load the Get Started setting."
    unavailableText="The switch for the Get Started checklist is not on this server yet."
    idPrefix="get-started-setting"
  />
);
